import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CurrencyPipe, NgClass } from '@angular/common';
import { SkeletonLoaderDirective } from 'sharedDirectives/skeleton-loader.directive';
import { PremiumBannerWidgetComponent } from './premium-banner-widget.component';

@Component({
    selector: 'premium-banner-simple-widget',
    templateUrl: './html/premium-banner-simple-widget.component.html',
    styleUrls: ['./css/premium-banner-widget.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, SkeletonLoaderDirective, CurrencyPipe],
})
export class PremiumBannerSimpleWidgetComponent extends PremiumBannerWidgetComponent {}
